import { html } from "lit";
import { customElement, property, queryAll, state } from "lit/decorators.js";
import { map } from 'lit/directives/map.js';
import { ContextData, MultiContextData, ReportContext } from "@reporting/rp-types/analytics";
import { style } from "./filters.style";
import { ComponentState, Layout, OmegaComponent } from "@omegagrid/core";
import { FilterSectionConfig } from "../../types";
import { ModuleDefinition } from "@reporting/rp-types/definition";
import { FilterAdapter } from "../../adapters/filterAdapter";
import { ReportTarget } from "../../actions";
import rp from '@reporting/rp-app-host';
import { FilterSection } from "./filterSection";

export type FilterState = {
	sections?: Record<string, ComponentState>;
}

export class FilterEvent extends Event {

	public readonly context: ReportContext;
	public readonly resultTarget: ReportTarget = 'active_tab';
	public readonly previewContextData: Partial<ContextData>;
	public readonly contextData: Partial<ContextData>;
	public readonly submitType: 'report' | 'query' | 'context';
	public readonly query: string;

	constructor(type: string, args: Partial<FilterEvent>) {
		super(`filter.${type}`, {bubbles: true, composed: true});
		Object.assign(this, args);
	}
}

@customElement('rp-filter')
export class Filter extends OmegaComponent<FilterState> implements Layout {

	static styles = [OmegaComponent.styles, style];

	@property({type: Object})
	adapter: FilterAdapter;

	@property({type: Object})
	module: ModuleDefinition;

	@property({type: Object})
	contextData: ContextData|MultiContextData;

	@state()
	sectionConfigs: FilterSectionConfig[];

	@queryAll('rp-fsection')
	sections: NodeListOf<FilterSection>;

	get service() { return rp.ms('analytics') }

	async reload() {
		this.sectionConfigs = await this.adapter.getSections(this.contextData);
	}

	async willUpdate(props: Map<string, any>) {
		if (props.has('contextData') && this.adapter) {
			this.sectionConfigs = await this.adapter.getSections(this.contextData);
		}

		if (props.has('adapter') && this.adapter) {
			this.adapter.attached(this);
		}
	}

	render = () => map(this.sectionConfigs, (sectionConfig, i) => html`
		<rp-fsection
			.state="${this.state?.sections?.[sectionConfig.type]}"
			@state="${() => this.updateState({sections: {[sectionConfig.type]: this.sections[i].state}})}"
			.config="${sectionConfig}"
			.module="${sectionConfig.module || this.module}"
			.contextData="${sectionConfig.contextData || this.contextData}">
		</rp-fsection>
	`);

	layout() {
		this.sections?.forEach(section => {
			if ((section as Layout).layout) section.layout();
		});
	}

}
